import { useState } from 'react';
import { Check, CheckCheck, Loader2 } from 'lucide-react';
import { formatTimeShort } from '../../../data/functions';

const fmtFullTime = (iso) =>
  new Date(iso).toLocaleString([], {
    hour: 'numeric',
    minute: '2-digit',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });

function MessageTimestamp({ message, currentUserId }) {
  const [expanded, setExpanded] = useState(false);

  const isMine = message.sender_id === currentUserId;
  const readBy = message.read_by || {};

  // For my messages: check if any other user has read it
  // For received messages: check if I have read it
  const otherUserId = isMine
    ? Object.keys(readBy).find(id => id !== currentUserId)
    : currentUserId;
  const isRead = otherUserId && otherUserId in readBy;
  const readTimestamp = isRead ? readBy[otherUserId] : null;

  const time = formatTimeShort(message.created_at);
  const fullSentTime = fmtFullTime(message.created_at);
  const fullSeenTime = readTimestamp ? fmtFullTime(readTimestamp) : null;

  return (
    <div className="flex flex-col gap-0.5 text-right">
      {/* Error, edited, and restored status */}
      {message.error && (
        <div className="text-[10px] text-red-500">
          {message.error}
        </div>
      )}
      {message.edited && !message.deleted && (
        <div className="text-[10px] text-muted-foreground">
          Edited: {formatTimeShort(message.edited_at)}
        </div>
      )}
      {!message.deleted && message.deleted_at && (
        <div className="text-[10px] text-muted-foreground">
          Restored {formatTimeShort(message.deleted_at)}
        </div>
      )}

      {/* Timestamp with read status */}
      {!isMine ? (
        <span>{time}</span>
      ) : (
        <div
          className="flex items-center gap-1 cursor-pointer justify-end"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? (
            <>
              <span>Sent {fullSentTime}</span>
              {message.sending ? (
                <Loader2 className="h-3 w-3 animate-spin" />
              ) : isRead ? (
                <>
                  <CheckCheck className="h-3 w-3 text-primary" />
                  <span>· Seen {fullSeenTime}</span>
                </>
              ) : (
                <Check className="h-3 w-3" />
              )}
            </>
          ) : (
            <>
              <span>{time}</span>
              {message.sending ? (
                <Loader2 className="h-3 w-3 animate-spin" />
              ) : isRead ? (
                <CheckCheck className="h-3 w-3 text-primary" />
              ) : (
                <Check className="h-3 w-3" />
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default MessageTimestamp;
